module.exports = __webpack_public_path__ + "static/media/city.4e4e2ff3.png";